import requestFunctions from "../../functions/requestFunctions";


export const state = {
  PROFILES_ITEM: {},
  PROFILES_LIST: [],
  PROFILES_TOTAL_ROWS: 0
}

export const getters = {
  GET_PROFILES_ITEM: (state) => {
    return state.PROFILES_ITEM;
  },
  GET_PROFILES_LIST: (state) => {
    return state.PROFILES_LIST;
  },
  GET_PROFILES_TOTAL_ROWS: (state) => {
    return state.PROFILES_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_PROFILES_ITEM(state, item) {
    state.PROFILES_ITEM = item;
  },
  UPDATE_PROFILES_LIST(state, list) {
    state.PROFILES_LIST = list.data;

    state.PROFILES_TOTAL_ROWS = list.total;
    list = list.data;
  },
}


export const actions = {

  async FETCH_PROFILES_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/profiles/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PROFILES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_PROFILES_LIST({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/profiles';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PROFILES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_PROFILES_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/profiles';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_PROFILES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/profiles/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_PROFILES_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/profiles/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}